import BaseController from 'lib/base-controller';
import GalleryScrollAction from 'lib/gallery-scroll-action';

import CityTemplate from 'templates/cities.html';


export default class CitiesController extends BaseController {

    /**
     * constructor
     */
    constructor (props, renderDone) {
        super();

        this.template = CityTemplate;
        this.context = {
            cities: this.getCities()
        };
        this.renderDone = renderDone;

        this.render();
    }

    /**
     * Destructor
     *
     * @param  {Function} done
     */
    destructor (done) {
        this.cityScrollAction.destructor();

        done();
    }

    /**
     * afterRender
     *
     * After render callback, to mainly initialize animation
     */
    afterRender () {
        super.afterRender();

        this.cityScrollAction = new GalleryScrollAction(document.querySelector('.js-cities-scroll-action'), false);

        this.renderDone();
    }

    /**
     * getCities
     *
     * Returns hardcoded array of city objects
     *
     * @return {Array}
     */
    getCities () {
        return [
            {
                name: 'london',
                img: '/media/img/cities/london_thumb.jpg',
                url: '/city/london'
            },
            {
                name: 'berlin',
                img: '/media/img/cities/berlin_thumb.jpg',
                url: '/city/berlin'
            },
            {
                name: 'amsterdam',
                img: '/media/img/cities/amsterdam_thumb.jpg',
                url: '/city/amsterdam'
            },
        ];
    }
}



// WEBPACK FOOTER //
// ./controllers/cities.js